import axios from "axios"
import React, { Suspense, useEffect, useState } from "react"
import { Helmet } from "react-helmet"
import TrackVisibility from "react-on-screen"
import Layout from "../components/Layout"
import Progress from "../components/Progress"
import Resume from "../components/Resume"
import Sectiontitle from "../components/Sectiontitle"
import Smalltitle from "../components/Smalltitle"
import Spinner from "../components/Spinner"

interface Skill {
  id: string | number
  title: string
  value: number
}

interface Experience {
  id: string | number
  year: string
  position?: string
  graduation?: string
  university?: string
  company?: string
  details: string
  [key: string]: unknown
}

interface ExperienceResponse {
  workExperience: Experience[]
  educationExperience: Experience[]
}

const ResumePage: React.FC = () => {
  const [skills, setSkills] = useState<Skill[]>([])
  const [workExperience, setWorkExperience] = useState<Experience[]>([])
  const [educationExperience, setEducationExperience] = useState<Experience[]>([])

  // Flip the order of the work experience
  const sortedWorkExperience = workExperience.slice().reverse()

  useEffect(() => {
    axios.get<Skill[]>("/api/skills").then((response) => {
      setSkills(response.data)
    })
    axios.get<ExperienceResponse>("/api/experience").then((response) => {
      setWorkExperience(response.data.workExperience)
      setEducationExperience(response.data.educationExperience)
    })
  }, [])

  return (
    <Layout>
      <Helmet>
        <title>CV - Nathan Hensher</title>
        <meta
          name="description"
          content="Nathan Hensher - Javascript Engineer - CV"
        />
      </Helmet>
      <Suspense fallback={<Spinner />}>
        <div className="mi-skills-area mi-section mi-padding-top">
          <div className="container">
            <Sectiontitle title="My Skills" />
            <div className="mi-skills">
              <div className="row mt-30-reverse">
                {skills.map((skill) => (
                  <TrackVisibility
                    once
                    className="col-lg-6 mt-30"
                    key={skill.title + skill.id}
                  >
                    <Progress title={skill.title} percentage={skill.value} />
                  </TrackVisibility>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="mi-cv-area mi-section mi-padding-top mi-padding-bottom">
          <div className="container">
            <Sectiontitle title="CV" />
            <Smalltitle title="Working Experience" icon="briefcase" />
            <div className="mi-cv-wrapper">
              {sortedWorkExperience.map((workingExp) => (
                <Resume key={workingExp.id} resumeData={workingExp} />
              ))}
            </div>
            <div className="mt-30"></div>
            <Smalltitle title="Educational Qualifications" icon="book" />
            <div className="mi-cv-wrapper">
              {educationExperience.map((educationExp) => (
                <Resume key={educationExp.id} resumeData={educationExp} />
              ))}
            </div>
          </div>
        </div>
      </Suspense>
    </Layout>
  )
}

export default ResumePage
